module.exports = __webpack_public_path__ + "static/media/Barmag FK6 Jockey Pulley.5d2519de.jpg";